// main ===========================================================
export const LOADED = 'LOADED';
export const AUTH_LOGGED = 'AUTH_LOGGED';
export const AUTH_ANONYMOUS = 'AUTH_ANONYMOUS';
export const AUTH_TEAMS = 'AUTH_TEAMS';
export const PAGE_ERROR = 'PAGE_ERROR';

// auth ===========================================================
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const MICROSOFT_LOGIN_SUCCESS = 'MICROSOFT_LOGIN_SUCCESS';
export const OAUTH_REQUEST = 'OAUTH_REQUEST';
export const OAUTH_SUCCESS = 'OAUTH_SUCCESS';
export const OAUTH_FAILED = 'OAUTH_FAILED';
export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_LOGIN_SUCCESS = 'REFRESH_TOKEN_LOGIN_SUCCESS';
export const REFRESH_TOKEN_LOGIN_FAILED = 'REFRESH_TOKEN_LOGIN_FAILED';
export const REQUEST_TOKEN_REQUEST = 'REQUEST_TOKEN_REQUEST';
export const REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS';
export const REQUEST_TOKEN_FAILED = 'REQUEST_TOKEN_FAILED';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const GET_STARTED_REQUEST = 'GET_STARTED_REQUEST';
export const GET_STARTED_SUCCESS = 'GET_STARTED_SUCCESS';
export const GET_STARTED_FAILED = 'GET_STARTED_FAILED';
export const LOGOUT = 'LOGOUT';
export const CHECK_ACCOUNT_REQUEST = 'CHECK_ACCOUNT_REQUEST';
export const CHECK_ACCOUNT_SUCCESS = 'CHECK_ACCOUNT_SUCCESS';
export const CHECK_ACCOUNT_FAILED = 'CHECK_ACCOUNT_FAILED';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';

// ms teams ===========================================================
export const LOGIN_TEAMS_REQUEST = 'LOGIN_TEAMS_REQUEST';
export const LOGIN_TEAMS_SUCCESS = 'LOGIN_TEAMS_SUCCESS';
export const LOGIN_TEAMS_FAILED = 'LOGIN_TEAMS_FAILED';

// companies ===========================================================
export const GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_SUCCESS_UNBATCHED =
  'GET_COMPANIES_SUCCESS_UNBATCHED';
export const GET_COMPANIES_FAILED = 'GET_COMPANIES_FAILED';
export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_FAILED = 'GET_COMPANY_FAILED';
export const GET_COMPANIES_DATA_REQUEST = 'GET_COMPANIES_DATA_REQUEST';
export const GET_COMPANIES_DATA_SUCCESS = 'GET_COMPANIES_DATA_SUCCESS';
export const GET_COMPANIES_DATA_FAILED = 'GET_COMPANIES_DATA_FAILED';
export const GET_COMPANY_CONTACTS_REQUEST = 'GET_COMPANY_CONTACTS_REQUEST';
export const GET_COMPANY_CONTACTS_SUCCESS = 'GET_COMPANY_CONTACTS_SUCCESS';
export const GET_COMPANY_CONTACTS_FAILED = 'GET_COMPANY_CONTACTS_FAILED';
export const GET_COMPANY_SCORE_HISTORY_REQUEST =
  'GET_COMPANY_SCORE_HISTORY_REQUEST';
export const GET_COMPANY_SCORE_HISTORY_SUCCESS =
  'GET_COMPANY_SCORE_HISTORY_SUCCESS';
export const GET_COMPANY_SCORE_HISTORY_FAILED =
  'GET_COMPANY_SCORE_HISTORY_FAILED';
export const GET_COMPANY_INTERACTION_SUMMARY_REQUEST =
  'GET_COMPANY_INTERACTION_SUMMARY_REQUEST';
export const GET_COMPANY_INTERACTION_SUMMARY_SUCCESS =
  'GET_COMPANY_INTERACTION_SUMMARY_SUCCESS';
export const GET_COMPANY_INTERACTION_SUMMARY_FAILED =
  'GET_COMPANY_INTERACTION_SUMMARY_FAILED';
export const UPDATE_COMPANY_CUSTOM_FIELDS_REQUEST =
  'UPDATE_COMPANY_CUSTOM_FIELDS_REQUEST';
export const UPDATE_COMPANY_CUSTOM_FIELDS_SUCCESS =
  'UPDATE_COMPANY_CUSTOM_FIELDS_SUCCESS';
export const UPDATE_COMPANY_CUSTOM_FIELDS_FAILED =
  'UPDATE_COMPANY_CUSTOM_FIELDS_FAILED';
export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAILED = 'UPDATE_COMPANY_FAILED';
export const UPDATE_COMPANIES_REQUEST = 'UPDATE_COMPANIES_REQUEST';
export const UPDATE_COMPANIES_SUCCESS = 'UPDATE_COMPANIES_SUCCESS';
export const UPDATE_COMPANIES_FAILED = 'UPDATE_COMPANIES_FAILED';
export const VALIDATE_COMPANY_REQUEST = 'VALIDATE_COMPANY_REQUEST';
export const VALIDATE_COMPANY_SUCCESS = 'VALIDATE_COMPANY_SUCCESS';
export const VALIDATE_COMPANY_FAILED = 'VALIDATE_COMPANY_FAILED';
export const ADD_COMPANY_REQUEST = 'ADD_COMPANY_REQUEST';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_FAILED = 'ADD_COMPANY_FAILED';
export const NEW_COMPANY = 'NEW_COMPANY';
export const GET_COMPANY_NEWS_REQUEST = 'GET_COMPANY_NEWS_REQUEST';
export const GET_COMPANY_NEWS_SUCCESS = 'GET_COMPANY_NEWS_SUCCESS';
export const GET_COMPANY_NEWS_FAILED = 'GET_COMPANY_NEWS_FAILED';
export const DELETE_COMPANY_REQUEST = 'DELETE_COMPANY_REQUEST';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';
export const DELETE_COMPANY_FAILED = 'DELETE_COMPANY_FAILED';
export const GET_COMPANY_PLANNED_INTERACTIONS_REQUEST =
  'GET_COMPANY_PLANNED_INTERACTIONS_REQUEST';
export const GET_COMPANY_PLANNED_INTERACTIONS_SUCCESS =
  'GET_COMPANY_PLANNED_INTERACTIONS_SUCCESS';
export const GET_COMPANY_PLANNED_INTERACTIONS_FAILED =
  'GET_COMPANY_PLANNED_INTERACTIONS_FAILED';
export const GET_COMPANY_PLANNED_INTERACTION_SUMMARY_REQUEST =
  'GET_COMPANY_PLANNED_INTERACTION_SUMMARY_REQUEST';
export const GET_COMPANY_PLANNED_INTERACTION_SUMMARY_SUCCESS =
  'GET_COMPANY_PLANNED_INTERACTION_SUMMARY_SUCCESS';
export const GET_COMPANY_PLANNED_INTERACTION_SUMMARY_FAILED =
  'GET_COMPANY_PLANNED_INTERACTION_SUMMARY_FAILED';
export const UPDATE_COMPANY_PROPERTY = 'UPDATE_COMPANY_PROPERTY';
export const CANCEL_COMPANY_INLINE_EDIT = 'CANCEL_COMPANY_INLINE_EDIT';
export const BULK_SAVE_COMPANIES_COMPLETED = 'BULK_SAVE_COMPANIES_COMPLETED';

// contacts ===========================================================
export const COMPANY_CONTACTS_CACHE_UPDATE = 'COMPANY_CONTACTS_CACHE_UPDATE';
export const GET_CONTACTS_REQUEST = 'GET_CONTACTS_REQUEST';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_SUCCESS_UNBATCHED = 'GET_CONTACTS_SUCCESS_UNBATCHED';
export const GET_CONTACTS_FAILED = 'GET_CONTACTS_FAILED';
export const GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST';
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
export const GET_CONTACT_FAILED = 'GET_CONTACT_FAILED';
export const GET_CONTACTS_DATA_REQUEST = 'GET_CONTACTS_DATA_REQUEST';
export const GET_CONTACTS_DATA_SUCCESS = 'GET_CONTACTS_DATA_SUCCESS';
export const GET_CONTACTS_DATA_FAILED = 'GET_CONTACTS_DATA_FAILED';
export const GET_CONTACT_SCORE_HISTORY_REQUEST =
  'GET_CONTACT_SCORE_HISTORY_REQUEST';
export const GET_CONTACT_SCORE_HISTORY_SUCCESS =
  'GET_CONTACT_SCORE_HISTORY_SUCCESS';
export const GET_CONTACT_SCORE_HISTORY_FAILED =
  'GET_CONTACT_SCORE_HISTORY_FAILED';
export const UPDATE_CONTACT_CUSTOM_FIELDS_REQUEST =
  'UPDATE_CONTACT_CUSTOM_FIELDS_REQUEST';
export const UPDATE_CONTACT_CUSTOM_FIELDS_SUCCESS =
  'UPDATE_CONTACT_CUSTOM_FIELDS_SUCCESS';
export const UPDATE_CONTACT_CUSTOM_FIELDS_FAILED =
  'UPDATE_CONTACT_CUSTOM_FIELDS_FAILED';
export const UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST';
export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS';
export const UPDATE_CONTACT_FAILED = 'UPDATE_CONTACT_FAILED';
export const UPDATE_CONTACTS_REQUEST = 'UPDATE_CONTACTS_REQUEST';
export const UPDATE_CONTACTS_SUCCESS = 'UPDATE_CONTACTS_SUCCESS';
export const UPDATE_CONTACTS_FAILED = 'UPDATE_CONTACTS_FAILED';
export const VALIDATE_CONTACT_REQUEST = 'VALIDATE_CONTACT_REQUEST';
export const VALIDATE_CONTACT_SUCCESS = 'VALIDATE_CONTACT_SUCCESS';
export const VALIDATE_CONTACT_FAILED = 'VALIDATE_CONTACT_FAILED';
export const VALIDATE_EMAIL_REQUEST = 'VALIDATE_EMAIL_REQUEST';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
export const VALIDATE_EMAIL_FAILED = 'VALIDATE_EMAIL_FAILED';
export const VALIDATE_PHONE_REQUEST = 'VALIDATE_PHONE_REQUEST';
export const VALIDATE_PHONE_SUCCESS = 'VALIDATE_PHONE_SUCCESS';
export const VALIDATE_PHONE_FAILED = 'VALIDATE_PHONE_FAILED';
export const ADD_CONTACT_REQUEST = 'ADD_CONTACT_REQUEST';
export const ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS';
export const ADD_CONTACT_FAILED = 'ADD_CONTACT_FAILED';
export const DELETE_CONTACT_REQUEST = 'DELETE_CONTACT_REQUEST';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILED = 'DELETE_CONTACT_FAILED';
export const SET_BULK_DATA = 'SET_BULK_DATA';
export const CLEAR_BULK_DATA = 'CLEAR_BULK_DATA';
export const VALIDATE_BULK_IMPORT_REQUEST = 'VALIDATE_BULK_IMPORT_REQUEST';
export const VALIDATE_BULK_IMPORT_SUCCESS = 'VALIDATE_BULK_IMPORT_SUCCESS';
export const VALIDATE_BULK_IMPORT_FAILED = 'VALIDATE_BULK_IMPORT_FAILED';
export const BULK_IMPORT_REQUEST = 'BULK_IMPORT_REQUEST';
export const BULK_IMPORT_SUCCESS = 'BULK_IMPORT_SUCCESS';
export const BULK_IMPORT_FAILED = 'BULK_IMPORT_FAILED';
export const PREDICT_ROLE_REQUEST = 'PREDICT_ROLE_REQUEST';
export const PREDICT_ROLE_SUCCESS = 'PREDICT_ROLE_SUCCESS';
export const PREDICT_ROLE_FAILED = 'PREDICT_ROLE_FAILED';
export const UPDATE_CONTACT_PROPERTY = 'UPDATE_CONTACT_PROPERTY';
export const CANCEL_CONTACT_INLINE_EDIT = 'CANCEL_CONTACT_INLINE_EDIT';
export const BULK_SAVE_CONTACTS_COMPLETED = 'BULK_SAVE_CONTACTS_COMPLETED';

// profile ===========================================================
export const CAN_CHANGE_PASSWORD_REQUEST = 'CAN_CHANGE_PASSWORD_REQUEST';
export const CAN_CHANGE_PASSWORD_SUCCESS = 'CAN_CHANGE_PASSWORD_SUCCESS';
export const CAN_CHANGE_PASSWORD_FAILED = 'CAN_CHANGE_PASSWORD_FAILED';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
export const HELP_REQUEST = 'HELP_REQUEST';
export const HELP_SUCCESS = 'HELP_SUCCESS';
export const HELP_FAILED = 'HELP_FAILED';
export const GET_ALL_SUGGESTED_CONTACTS_REQUEST =
  'GET_ALL_SUGGESTED_CONTACTS_REQUEST';
export const GET_ALL_SUGGESTED_CONTACTS_SUCCESS =
  'GET_ALL_SUGGESTED_CONTACTS_SUCCESS';
export const GET_ALL_SUGGESTED_CONTACTS_FAILED =
  'GET_ALL_SUGGESTED_CONTACTS_FAILED';
export const GET_PREVIEW_SUGGESTED_CONTACTS_REQUEST =
  'GET_PREVIEW_SUGGESTED_CONTACTS_REQUEST';
export const GET_PREVIEW_SUGGESTED_CONTACTS_SUCCESS =
  'GET_PREVIEW_SUGGESTED_CONTACTS_SUCCESS';
export const GET_PREVIEW_SUGGESTED_CONTACTS_FAILED =
  'GET_PREVIEW_SUGGESTED_CONTACTS_FAILED';
export const REMOVE_SUGGESTED_CONTACT_REQUEST = 'GET_SUGGESTED_CONTACTS_FAILED';
export const REMOVE_SUGGESTED_CONTACT_SUCCESS =
  'REMOVE_SUGGESTED_CONTACT_SUCCESS';
export const REMOVE_SUGGESTED_CONTACT_FAILED =
  'REMOVE_SUGGESTED_CONTACT_FAILED';

// account ===========================================================
export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAILED = 'GET_ACCOUNT_FAILED';
export const GET_ACCOUNT_CONFIG_REQUEST = 'GET_ACCOUNT_CONFIG_REQUEST';
export const GET_ACCOUNT_CONFIG_SUCCESS = 'GET_ACCOUNT_CONFIG_SUCCESS';
export const GET_ACCOUNT_CONFIG_FAILED = 'GET_ACCOUNT_CONFIG_FAILED';
export const GET_BILLING_PLAN_REQUEST = 'GET_BILLING_PLAN_REQUEST';
export const GET_BILLING_PLAN_SUCCESS = 'GET_BILLING_PLAN_SUCCESS';
export const GET_BILLING_PLAN_FAILED = 'GET_BILLING_PLAN_FAILED';
export const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILED = 'GET_INVOICES_FAILED';
export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILED = 'CREATE_SUBSCRIPTION_FAILED';

export const RESYNC_365_CALENDARS_REQUEST = 'RESYNC_365_CALENDARS_REQUEST';
export const RESYNC_365_CALENDARS_SUCCESS = 'RESYNC_365_CALENDARS_SUCCESS';
export const RESYNC_365_CALENDARS_FAILED = 'RESYNC_365_CALENDARS_FAILED';

export const UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST';
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS';
export const UPDATE_CARD_FAILED = 'UPDATE_CARD_FAILED';

// portfolio ===========================================================
export const GET_PORTFOLIO_REQUEST = 'GET_PORTFOLIO_REQUEST';
export const GET_PORTFOLIO_SUCCESS = 'GET_PORTFOLIO_SUCCESS';
export const GET_PORTFOLIO_FAILED = 'GET_PORTFOLIO_FAILED';
export const PORTFOLIO_RELOAD = 'PORTFOLIO_RELOAD';

// reminders ===========================================================
export const ADD_REMINDER_REQUEST = 'ADD_REMINDER_REQUEST';
export const ADD_REMINDER_SUCCESS = 'ADD_REMINDER_SUCCESS';
export const ADD_REMINDER_FAILED = 'ADD_REMINDER_FAILED';
export const GET_REMINDERS_REQUEST = 'GET_REMINDERS_REQUEST';
export const GET_REMINDERS_SUCCESS = 'GET_REMINDERS_SUCCESS';
export const GET_REMINDERS_FAILED = 'GET_REMINDERS_FAILED';
export const ARCHIVE_REMINDER_REQUEST = 'ARCHIVE_REMINDER_REQUEST';
export const ARCHIVE_REMINDER_SUCCESS = 'ARCHIVE_REMINDER_SUCCESS';
export const ARCHIVE_REMINDER_FAILED = 'ARCHIVE_REMINDER_FAILED';
export const UNARCHIVE_REMINDER_REQUEST = 'UNARCHIVE_REMINDER_REQUEST';
export const UNARCHIVE_REMINDER_SUCCESS = 'UNARCHIVE_REMINDER_SUCCESS';
export const UNARCHIVE_REMINDER_FAILED = 'UNARCHIVE_REMINDER_FAILED';
export const UPDATE_REMINDER_REQUEST = 'UPDATE_REMINDER_REQUEST';
export const UPDATE_REMINDER_SUCCESS = 'UPDATE_REMINDER_SUCCESS';
export const UPDATE_REMINDER_FAILED = 'UPDATE_REMINDER_FAILED';
export const DELETE_REMINDER_REQUEST = 'DELETE_REMINDER_REQUEST';
export const DELETE_REMINDER_SUCCESS = 'DELETE_REMINDER_SUCCESS';
export const DELETE_REMINDER_FAILED = 'DELETE_REMINDER_FAILED';

// interactions ===========================================================
export const GET_INTERACTION_REQUEST = 'GET_INTERACTION_REQUEST';
export const GET_INTERACTION_SUCCESS = 'GET_INTERACTION_SUCCESS';
export const GET_INTERACTION_FAILED = 'GET_INTERACTION_FAILED';
export const GET_INTERACTIONS_SUCCESS = 'GET_INTERACTIONS_SUCCESS';
export const REVIEW_REQUEST = 'REVIEW_REQUEST';
export const REVIEW_SUCCESS = 'REVIEW_SUCCESS';
export const REVIEW_FAILED = 'REVIEW_FAILED';
export const UPDATE_NOTES_SUCCESS = 'UPDATE_NOTES_SUCCESS';
export const ADD_INTERACTION_REQUEST = 'ADD_INTERACTION_REQUEST';
export const ADD_INTERACTION_SUCCESS = 'ADD_INTERACTION_SUCCESS';
export const ADD_INTERACTION_FAILED = 'ADD_INTERACTION_FAILED';

// notifications ===========================================================
export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';
export const READ_REQUEST = 'READ_REQUEST';
export const READ_SUCCESS = 'READ_SUCCESS';
export const READ_FAILED = 'READ_FAILED';

// nbas ===========================================================
export const GET_NBAS_REQUEST = 'GET_NBAS_REQUEST';
export const GET_NBAS_SUCCESS = 'GET_NBAS_SUCCESS';
export const GET_NBAS_FAILED = 'GET_NBAS_FAILED';
export const REMOVE_NBA = 'REMOVE_NBA';

// Users ===========================================================
export const INVITE_USER = 'INVITE_USER';
export const INVITE_USERS_REQUEST = 'INVITE_USERS_REQUEST';
export const INVITE_USERS_SUCCESS = 'INVITE_USERS_SUCCESS';
export const INVITE_USERS_FAILED = 'INVITE_USERS_FAILED';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GET_USER_CHECKLIST_REQUEST = 'GET_USER_CHECKLIST_REQUEST';
export const GET_USER_CHECKLIST_SUCCESS = 'GET_USER_CHECKLIST_SUCCESS';
export const GET_USER_CHECKLIST_FAILED = 'GET_USER_CHECKLIST_FAILED';
export const SET_USER_CHECKLIST_REQUEST = 'SET_USER_CHECKLIST_REQUEST';
export const SET_USER_CHECKLIST_SUCCESS = 'SET_USER_CHECKLIST_SUCCESS';
export const SET_USER_CHECKLIST_FAILED = 'SET_USER_CHECKLIST_FAILED';
export const GET_USER_VIEWS_REQUEST = 'GET_USER_VIEWS_REQUEST';
export const GET_USER_VIEWS_SUCCESS = 'GET_USER_VIEWS_SUCCESS';
export const GET_USER_VIEWS_FAILED = 'GET_USER_VIEWS_FAILED';
export const ORDER_USER_VIEWS_REQUEST = 'ORDER_USER_VIEWS_REQUEST';
export const ORDER_USER_VIEWS_SUCCESS = 'ORDER_USER_VIEWS_SUCCESS';
export const ORDER_USER_VIEWS_FAILED = 'ORDER_USER_VIEWS_FAILED';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const UPDATE_USER_VIEW_REQUEST = 'UPDATE_USER_VIEW_REQUEST';
export const UPDATE_USER_VIEW_SUCCESS = 'UPDATE_USER_VIEW_SUCCESS';
export const UPDATE_USER_VIEW_FAILED = 'UPDATE_USER_VIEW_FAILED';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';
export const ARCHIVE_USER_REQUEST = 'ARCHIVE_USER_REQUEST';
export const ARCHIVE_USER_SUCCESS = 'ARCHIVE_USER_SUCCESS';
export const ARCHIVE_USER_FAILED = 'ARCHIVE_USER_FAILED';
export const REVOKE_INVITE_REQUEST = 'REVOKE_INVITE_REQUEST';
export const REVOKE_INVITE_SUCCESS = 'REVOKE_INVITE_SUCCESS';
export const REVOKE_INVITE_FAILED = 'REVOKE_INVITE_FAILED';
export const VALIDATE_REGISTRATION_EMAIL_REQUEST =
  'VALIDATE_REGISTRATION_EMAIL_REQUEST';
export const VALIDATE_REGISTRATION_EMAIL_SUCCESS =
  'VALIDATE_REGISTRATION_EMAIL_SUCCESS';
export const VALIDATE_REGISTRATION_EMAIL_FAILED =
  'VALIDATE_REGISTRATION_EMAIL_FAILED';
export const VALIDATE_INVITE_TOKEN_REQUEST = 'VALIDATE_INVITE_TOKEN_REQUEST';
export const VALIDATE_INVITE_TOKEN_SUCCESS = 'VALIDATE_INVITE_TOKEN_SUCCESS';
export const VALIDATE_INVITE_TOKEN_FAILED = 'VALIDATE_INVITE_TOKEN_FAILED';
export const VALIDATE_INVITE_PHONE_REQUEST = 'VALIDATE_INVITE_PHONE_REQUEST';
export const VALIDATE_INVITE_PHONE_SUCCESS = 'VALIDATE_INVITE_PHONE_SUCCESS';
export const VALIDATE_INVITE_PHONE_FAILED = 'VALIDATE_INVITE_PHONE_FAILED';
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const AUTH_OFFICE365_REQUEST = 'AUTH_OFFICE365_REQUEST';
export const AUTH_OFFICE365_SUCCESS = 'AUTH_OFFICE365_SUCCESS';
export const AUTH_OFFICE365_FAILED = 'AUTH_OFFICE365_FAILED';
export const GET_OFFICE365_AUTH_STATUS_REQUEST =
  'GET_OFFICE365_AUTH_STATUS_REQUEST';
export const GET_OFFICE365_AUTH_STATUS_SUCCESS =
  'GET_OFFICE365_AUTH_STATUS_SUCCESS';
export const GET_OFFICE365_AUTH_STATUS_FAILED =
  'GET_OFFICE365_AUTH_STATUS_FAILED';
export const GET_OFFICE365_CONTACTS_REQUEST = 'GET_OFFICE365_CONTACTS_REQUEST';
export const GET_OFFICE365_CONTACTS_SUCCESS = 'GET_OFFICE365_CONTACTS_SUCCESS';
export const GET_OFFICE365_CONTACTS_FAILED = 'GET_OFFICE365_CONTACTS_FAILED';
export const GET_INTEGRATION_SUBSCRIPTIONS_REQUEST = 'GET_USERS_REQUEST';
export const GET_INTEGRATION_SUBSCRIPTIONS_SUCCESS =
  'GET_INTEGRATION_SUBSCRIPTIONS_SUCCESS';
export const GET_INTEGRATION_SUBSCRIPTIONS_FAILED =
  'GET_INTEGRATION_SUBSCRIPTIONS_FAILED';
export const REMOVE_INTEGRATION_SUBSCRIPTION_REQUEST =
  'REMOVE_INTEGRATION_SUBSCRIPTION_REQUEST';
export const REMOVE_INTEGRATION_SUBSCRIPTION_SUCCESS =
  'REMOVE_INTEGRATION_SUBSCRIPTION_SUCCESS';
export const REMOVE_INTEGRATION_SUBSCRIPTION_FAILED =
  'REMOVE_INTEGRATION_SUBSCRIPTION_FAILED';
export const RETRY_INTEGRATION_SUBSCRIPTION_REQUEST =
  'RETRY_INTEGRATION_SUBSCRIPTION_REQUEST';
export const RETRY_INTEGRATION_SUBSCRIPTION_SUCCESS =
  'RETRY_INTEGRATION_SUBSCRIPTION_SUCCESS';
export const RETRY_INTEGRATION_SUBSCRIPTION_FAILED =
  'RETRY_INTEGRATION_SUBSCRIPTION_FAILED';

// Settings ========================================================
export const UPDATE_RELATIONSHIP_SCORE_REQUEST =
  'UPDATE_RELATIONSHIP_SCORE_REQUEST';
export const UPDATE_RELATIONSHIP_SCORE_SUCCESS =
  'UPDATE_RELATIONSHIP_SCORE_SUCCESS';
export const UPDATE_RELATIONSHIP_SCORE_FAILED =
  'UPDATE_RELATIONSHIP_SCORE_FAILED';
export const IMPORT_CONTACTS_UPLOAD_REQUEST = 'IMPORT_CONTACTS_UPLOAD_REQUEST';
export const IMPORT_CONTACTS_UPLOAD_SUCCESS = 'IMPORT_CONTACTS_UPLOAD_SUCCESS';
export const IMPORT_CONTACTS_UPLOAD_FAILED = 'IMPORT_CONTACTS_UPLOAD_FAILED';
export const UPDATE_ACCOUNT_VISIBILITY_REQUEST =
  'UPDATE_ACCOUNT_VISIBILITY_REQUEST';
export const UPDATE_ACCOUNT_VISIBILITY_SUCCESS =
  'UPDATE_ACCOUNT_VISIBILITY_SUCCESS';
export const UPDATE_ACCOUNT_VISIBILITY_FAILED =
  'UPDATE_ACCOUNT_VISIBILITY_FAILED';

export const UPDATE_IMPORT_RECURRING_MEETINGS_REQUEST =
  'UPDATE_IMPORT_RECURRING_MEETINGS_REQUEST';
export const UPDATE_IMPORT_RECURRING_MEETINGS_SUCCESS =
  'UPDATE_IMPORT_RECURRING_MEETINGS_SUCCESS';
export const UPDATE_IMPORT_RECURRING_MEETINGS_FAILED =
  'UPDATE_IMPORT_RECURRING_MEETINGS_FAILED';

// Fields ========================================================
export const GET_FIELDS_REQUEST = 'GET_FIELDS_REQUEST';
export const GET_FIELDS_SUCCESS = 'GET_FIELDS_SUCCESS';
export const GET_FIELDS_FAILED = 'GET_FIELDS_FAILED';
export const UPDATE_FIELD_REQUEST = 'UPDATE_FIELD_REQUEST';
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS';
export const UPDATE_FIELD_FAILED = 'UPDATE_FIELD_FAILED';

// Drawer ========================================================
export const CLEAR_DRAWER = 'CLEAR_DRAWER';
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const SET_DRAWER_INDEX = 'SET_DRAWER_INDEX';
export const REMOVE_DRAWER_STAGE = 'REMOVE_DRAWER_STAGE';

// Modal Stack ========================================================
export const CLEAR_MODAL = 'CLEAR_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';
export const OPEN_MODAL_STAGE = 'OPEN_MODAL_STAGE';
export const UPDATE_MODAL = 'UPDATE_MODAL';
export const SET_MODAL_INDEX = 'SET_MODAL_INDEX';
export const REMOVE_MODAL_STAGE = 'REMOVE_MODAL_STAGE';

// Files ===========================================================
export const GET_FILES_REQUEST = 'GET_FILES_REQUEST';
export const GET_FILES_SUCCESS = 'GET_FILES_SUCCESS';
export const GET_FILES_FAILED = 'GET_FILES_FAILED';
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILED = 'DELETE_FILE_FAILED';
export const ADD_FILE_REQUEST = 'ADD_FILE_REQUEST';
export const ADD_FILE_SUCCESS = 'ADD_FILE_SUCCESS';
export const ADD_FILE_FAILED = 'Add_FILE_FAILED';
export const FINALISE_FILE_REQUEST = 'FINALISE_FILE_REQUEST';
export const FINALISE_FILE_SUCCESS = 'FINALISE_FILE_SUCCESS';
export const FINALISE_FILE_FAILED = 'FINALISE_FILE_FAILED';

// Views ===========================================================
export const GET_VIEWS_REQUEST = 'GET_VIEWS_REQUEST';
export const GET_VIEWS_SUCCESS = 'GET_VIEWS_SUCCESS';
export const GET_VIEWS_FAILED = 'GET_VIEWS_FAILED';
export const UPDATE_VIEW_REQUEST = 'UPDATE_VIEW_REQUEST';
export const UPDATE_VIEW_SUCCESS = 'UPDATE_VIEW_SUCCESS';
export const UPDATE_VIEW_FAILED = 'UPDATE_VIEW_FAILED';
export const NEW_VIEW_REQUEST = 'NEW_VIEW_REQUEST';
export const NEW_VIEW_SUCCESS = 'NEW_VIEW_SUCCESS';
export const NEW_VIEW_FAILED = 'NEW_VIEW_FAILED';
